import { createStore } from '@stencil/store';

const { state } = createStore({
  term: '',
  answers: [],
});

const communityWidgetStore = {
  state
};

export default communityWidgetStore;